import { render, staticRenderFns } from "./addIssue.vue?vue&type=template&id=35e31096&scoped=true"
import script from "./addIssue.vue?vue&type=script&lang=js"
export * from "./addIssue.vue?vue&type=script&lang=js"
import style0 from "./addIssue.vue?vue&type=style&index=0&id=35e31096&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e31096",
  null
  
)

export default component.exports